import React from 'react';
import {useLocation,Navigate} from 'react-router-dom';
import {TeamHubRedirect} from '../components/team-center/TeamHubRedirect';
export default function PrepCenterPage(){
  const location=useLocation(),params=new URLSearchParams(location.search),panel=params.get('panel');
  if(panel==='my-routine'){params.delete('panel');return <Navigate replace to={{pathname:'/my-routine',search:params.toString()?'?'+params:'',hash:location.hash}}/>;}
  const tool=location.pathname.includes('homework')||panel==='my-homework'?'homework':location.pathname.includes('decisions')||location.pathname.includes('voting')||panel==='veto'?'decisions':location.pathname.includes('protocols')||panel==='protocols'?'protocols':'prep';
  return <TeamHubRedirect tool={tool}/>;
}
